// extracted by mini-css-extract-plugin
export var container = "imageSection-module--container--fba5b";
export var content = "imageSection-module--content--d2322";
export var image = "imageSection-module--image--35f22";
export var imageDesktop = "imageSection-module--imageDesktop--8de91";
export var normal = "imageSection-module--normal--3487f";
export var portrait = "imageSection-module--portrait--4b0be";
export var reverse = "imageSection-module--reverse--32f1e";
export var title = "imageSection-module--title--29c74";
export var wrapper = "imageSection-module--wrapper--f8f32";
export var wrapperBgBlack = "imageSection-module--wrapperBgBlack--c9216";
export var wrapperBgGrey = "imageSection-module--wrapperBgGrey--50d11";
export var wrapperBgWhite = "imageSection-module--wrapperBgWhite--eb02c";